
import { authMiddleware } from './auth.middleware';

const middlewares = [
    authMiddleware
];

export default middlewares;